import React, { createContext, useContext, useState } from 'react';
import { TRANSLATIONS } from '../config/translations';

const LangContext = createContext({
  lang: 'en',
  setLang: () => {},
  t: TRANSLATIONS.en,
});

export function LangProvider({ children }) {
  const [lang, setLang] = useState('en');
  const t = TRANSLATIONS[lang] || TRANSLATIONS.en;

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
